export default __webpack_public_path__ + "static/media/portfolio2.0d117e11.png";